// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Simple progress bar styles */
.progress-bar-container {
  height: 8px;
  background: transparent;
  border-radius: 8px;
  overflow: hidden;
  box-sizing: border-box;
}

.progress-bar-bg {
  width: 100%;
  height: 8px;
  background: #e0e0e0;
  border-radius: 8px;
  position: relative;
}

.progress-bar-fill {
  height: 100%;
  border-radius: 8px;
  transition: width 0.4s;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: bold;
  font-size: 13px;
}

.progress-bar-percentage {
  position: absolute;
  left: 8px;
  /* Move text a bit right */
  top: 50%;
  transform: translateY(-50%);
  width: max-content;
  color: white;
  font-weight: normal;
  font-size: 11px;
  font-style: normal;
  pointer-events: none;
  z-index: 2;
}
`, "",{"version":3,"sources":["webpack://./src/css/progressbar.css"],"names":[],"mappings":"AAAA,+BAA+B;AAC/B;EACE,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,0BAA0B;EAC1B,QAAQ;EACR,2BAA2B;EAC3B,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,UAAU;AACZ","sourcesContent":["/* Simple progress bar styles */\n.progress-bar-container {\n  height: 8px;\n  background: transparent;\n  border-radius: 8px;\n  overflow: hidden;\n  box-sizing: border-box;\n}\n\n.progress-bar-bg {\n  width: 100%;\n  height: 8px;\n  background: #e0e0e0;\n  border-radius: 8px;\n  position: relative;\n}\n\n.progress-bar-fill {\n  height: 100%;\n  border-radius: 8px;\n  transition: width 0.4s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  font-weight: bold;\n  font-size: 13px;\n}\n\n.progress-bar-percentage {\n  position: absolute;\n  left: 8px;\n  /* Move text a bit right */\n  top: 50%;\n  transform: translateY(-50%);\n  width: max-content;\n  color: white;\n  font-weight: normal;\n  font-size: 11px;\n  font-style: normal;\n  pointer-events: none;\n  z-index: 2;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
